module.exports = __webpack_public_path__ + "static/media/34-2.1898f49a.mp3";